import React, { useState } from 'react'
import { Tooltip, IconButton } from '@mui/material'
import InfoModal from '../../asterX-UI/Modals/InfoModal'


/**
 * Универсальная кнопка-статус с подсказкой, SVG-иконкой и модалкой.
 *
 * @param {{
 *   icon: React.ReactNode,           // Иконка для отображения (SVG или MUI)
 *   tooltip: string,                 // Текст тултипа
 *   modalTitle: string,              // Заголовок модалки
 *   modalText: string,               // Описание/контент модалки
 *   modalVariant?: string,           // Вариант InfoModal (например, 'success' | 'warning' | 'error')
 *   btnSx?: object,                  // Стили для IconButton
 *   modalBtnText?: string            // Текст кнопки в модалке (по умолчанию "Закрыть")
 * }} props
 */
const InfoModalButton = ({
                                     icon,
                                     tooltip,
                                     modalTitle,
                                     modalText,
                                     modalVariant = 'info',
                                     btnSx = {},
                                     modalBtnText = 'Закрыть'
                                   }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton
          size="small"
          onClick={() => setOpen(true)}
          sx={{
            ...btnSx,
            borderRadius: '50%',
            p: 0.5
          }}
        >
          {icon}
        </IconButton>
      </Tooltip>
      <InfoModal
        open={open}
        onClose={() => setOpen(false)}
        title={modalTitle}
        variant={modalVariant}
        btnText={modalBtnText}
      >
        {modalText}
      </InfoModal>
    </>
  )
}

export default InfoModalButton
